/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = require('events').EventEmitter;




//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 391
// module chunks = 76